const ProductFormConstructor = customElements.get("product-form");
const LineItemQuantityConstructor = customElements.get("line-item-quantity");

window.addEventListener("DOMContentLoaded", () => {
  // Override ProductForm
  document.querySelectorAll('form[is="product-form"]').forEach((form) => {
    if (!form._onSubmit) {
      console.warn("⚠️ _onSubmit not found on form instance — aborting override.");
      return;
    }

    form.removeEventListener("submit", form._onSubmit);

    form._onSubmit = async function (event) {
      event.preventDefault();

      if (!this.checkValidity()) {
        this.reportValidity();
        return;
      }

      const submitButtons = Array.from(this.elements).filter((button) => button.type === "submit");
      submitButtons.forEach((submitButton) => {
        submitButton.setAttribute("disabled", "disabled");
        submitButton.setAttribute("aria-busy", "true");
      });

      const closestProduct = this.closest('.product');
      let productQnt = 1;

      if (closestProduct) {
        productQnt = closestProduct.querySelector('[name="quantity"]').value;
      }

      let formData = {};
      const uppCheckbox = document.getElementById("addInstallment");

      const items = [
        {
          id: Number(this.querySelector('[name="id"]').value),
          quantity: Number(productQnt),
          ...(uppCheckbox && uppCheckbox.checked
            ? { properties: { '_installmentProduct': uppCheckbox.value } }
            : {})
        },
      ];

      if (uppCheckbox && uppCheckbox.checked) {
        const installmentSize = parseInt(uppCheckbox.getAttribute('data-installment-products'), 10);
        const remainder = productQnt % installmentSize;

        let installmentTotal = Math.floor(productQnt / installmentSize) + (remainder > 0 ? 1 : 0);

        items.push({
          id: Number(uppCheckbox.value),
          quantity: Number(installmentTotal)
        });
      }

      // Webqam - modify the section with id
        const cartDrawerElement = document.querySelector('cart-drawer');
        const cartDrawerSection = cartDrawerElement ? cartDrawerElement.closest('.shopify-section') : null;
        const sectionId = cartDrawerSection ? cartDrawerSection.id.replace('shopify-section-', '') : 'cart-drawer';
        const sections = `${sectionId},variant-added`;
        //const sections = "cart-drawer,variant-added";
      //end webqam

      const sections_url = `${Shopify.routes.root}variants/${this.id.value}`;

      formData = {
        items,
        sections,
        sections_url,
      };

      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        body: JSON.stringify(formData),
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      });

      submitButtons.forEach((submitButton) => {
        submitButton.removeAttribute("disabled");
        submitButton.removeAttribute("aria-busy");
      });

      const responseJson = await response.json();
      if (response.ok) {
        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        cartContent["sections"] = responseJson["sections"];

        this.dispatchEvent(new CustomEvent("variant:add", {
          bubbles: true,
          detail: {
            items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
            cart: cartContent
          }
        }));

        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: cartContent
          }
        }));

        if (closestProduct && uppCheckbox && !uppCheckbox.checked) {
          const afterInstallmentPopup = document.querySelector("g-modal[id='after-add-modal']");
          if (afterInstallmentPopup) afterInstallmentPopup.open();
        }

      }
      else {
        this.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: responseJson["description"]
          }
        }));
      }
    };

    form.addEventListener("submit", form._onSubmit);
  });


  document.addEventListener("variant:add", (event) => {
    const checkbox = document.querySelector("#addInstallment");

    const shouldBlock = event.detail?.blockCartDrawerOpening || (checkbox && !checkbox.checked);

    if (shouldBlock) {
      document.querySelector("cart-drawer").hide();
      return;
    }
  })

});


const observeLineItems = () => {
  document.querySelectorAll("line-item-quantity").forEach((el) => {
    el.removeEventListener("click", el._onRemoveLinkClicked);
    el.removeEventListener("change", el._onQuantityChanged);

    el._onQuantityChanged = function (event) {
      if (!event.target.hasAttribute("data-line-key")) {
        return;
      }
      el._changeLineItemQuantity(event.target.getAttribute("data-line-key"), parseInt(event.target.value));
    }

    el._onRemoveLinkClicked = function (event) {
      if (event.target.tagName !== "A" || !event.target.href.includes("/cart/change")) return;
      event.preventDefault();
      const url = new URL(event.target.href);

      let installmentId;
      if (event.target.hasAttribute('data-installment')) {
        installmentId = event.target.getAttribute('data-installment');
      }

      this._changeLineItemQuantity(url.searchParams.get("id"), parseInt(url.searchParams.get("quantity")), installmentId);
    };

    el._changeLineItemQuantity = async function (lineKey, targetQuantity, installmentId) {
      console.log("this");

      const lineItem = this.closest("line-item");
      lineItem?.dispatchEvent(new CustomEvent("line-item:will-change", { bubbles: true, detail: { targetQuantity } }));

      let updates = { [lineKey]: targetQuantity };
      if (installmentId != null) {
        updates[installmentId] = targetQuantity;
      }

      // Webqam - modify the section with id
        const cartDrawerElement = document.querySelector('cart-drawer');
        const cartDrawerSection = cartDrawerElement ? cartDrawerElement.closest('.shopify-section') : null;
        const sectionId = cartDrawerSection ? cartDrawerSection.id.replace('shopify-section-', '') : 'cart-drawer';
      //end webqam

      //const sectionsArray = ["cart-drawer"];
      const sectionsArray = [sectionId]; // webqam
      const mainCart = document.querySelector('.shopify-section--main-cart');
      let mainCartId = "main-cart";
      if (mainCart) {
        mainCartId = mainCart.id.replace('shopify-section-', '');
        sectionsArray.push(mainCartId);
      }

      const itemsToUpdate = {
        updates,
        sections: sectionsArray,
      };

      const cartContent = await (await fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(itemsToUpdate)
      })).json();

      console.log('cartContent===', cartContent);

      const lineItemAfterChange = cartContent["items"].filter((lineItem2) => lineItem2["key"] === lineKey);
      lineItem?.dispatchEvent(new CustomEvent("line-item:change", {
        bubbles: true,
        detail: {
          quantity: lineItemAfterChange.length === 0 ? 0 : lineItemAfterChange[0]["quantity"],
          cart: cartContent
        }
      }));

      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "line-item:change",
          cart: cartContent
        }
      }));

      if (window.themeVariables.settings.pageType === "cart") {
        const mainCartContent = cartContent.sections[mainCartId];
        if (mainCartContent) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(mainCartContent, "text/html");
          const newCartContent = doc.querySelector(".shopify-section--main-cart");
          document.querySelector('[class*="main-cart"]').innerHTML = newCartContent.innerHTML;
        }
      }
    };

    el.addEventListener("click", el._onRemoveLinkClicked);
    el.addEventListener("change", el._onQuantityChanged);
  });
}

const observeQuantityInputs = () => {
  document.querySelectorAll('quantity-selector').forEach(selector => {
    const input = selector.querySelector("input");
    input.setAttribute("data-value", input.value);
    input.setAttribute("value", input.value);
    selector.querySelector("button:first-of-type").addEventListener("click", () => {
      input.setAttribute("data-value", input.value);
      input.setAttribute("value", input.value);
      document.dispatchEvent(new CustomEvent("installment:update"));

    });
    selector.querySelector("button:last-of-type").addEventListener("click", () => {
      input.setAttribute("data-value", input.value);
      input.setAttribute("value", input.value);
      document.dispatchEvent(new CustomEvent("installment:update"));
    });
  });
};

document.addEventListener("cart:change", observeLineItems);
document.addEventListener("cart:refresh", observeLineItems);
document.addEventListener("variant:add", observeLineItems);
document.addEventListener("dialog:after-show", observeLineItems);

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", observeQuantityInputs);
} else {
  observeQuantityInputs();
}

document.addEventListener('installment:update', () => {
  let uppCheckbox = document.querySelector('#addInstallment');
  let installmentEl = document.querySelector('[data-installment-price]');
  let productQnt = document.querySelector('[name="quantity"]').value;
  let modalAddInstallmentPrice = document.querySelector('.js-add-installment span');
  let modalCheckInstallmentPrice = document.querySelector('.js-installation-check span');

  if (installmentEl && productQnt) {
    let basePrice = parseFloat(installmentEl.getAttribute('data-installment-price')) || 0;
    let installmentValue = parseFloat(productQnt) || 0;

    const installmentSize = uppCheckbox.getAttribute('data-installment-products');
    const remainder = productQnt % installmentSize;

    let installmentTotal = Math.floor(productQnt / installmentSize) + (remainder > 0 ? 1 : 0);

    console.log('installmentTotal', remainder, installmentTotal, basePrice);


    let installmentPrice = (basePrice * installmentTotal) / 100;
    installmentEl.innerHTML = formatPrice(installmentPrice);

    modalAddInstallmentPrice.innerHTML = formatPrice(installmentPrice);
    modalCheckInstallmentPrice.innerHTML = formatPrice(installmentPrice);
  }
});

// Base modal class
class GModal extends HTMLElement {
  constructor() {
    super();
    this._content = null;
  }

  connectedCallback() {
    const backdrops = this.querySelectorAll('.modal-backdrop');
    if (backdrops.length) {
      backdrops.forEach((backdrop) => {
        backdrop.addEventListener('click', this.close.bind(this));
      });
    }
  }

  open() {
    document.documentElement.style.overflow = 'hidden';
    this.expanded = true;
  }

  close = async () => {
    document.documentElement.style.overflow = '';
    this.expanded = false;
    const cartDrawer = document.querySelector('.cart-drawer');
    if (cartDrawer) {
      await cartDrawer.show();
    }
  }

  toggle() {
    this.expanded ? this.close() : this.open();
  }

  onTrigger(event, triggerEl, action = 'open') {
    if (!triggerEl) {
      console.error("Trigger element isn't specified");
      return;
    }
    triggerEl.addEventListener(event, this[action]?.bind(this));
  }

  get expanded() {
    return this.getAttribute('aria-expanded') === 'true';
  }

  set expanded(value) {
    this.setAttribute('aria-expanded', Boolean(value));
  }

  get content() {
    if (!this._content) {
      this._content = this.querySelector('.js-content');
    }
    return this._content;
  }
}

// Dynamic modal class
class DynamicModal extends GModal {
  constructor() {
    super();
    this.currentContentKey = null;
  }

  onTrigger(event, triggerEl, action = 'open', contentKey) {
    if (!triggerEl) {
      console.error("Trigger element isn't specified");
      return;
    }

    if (['open', 'toggle'].includes(action) && !contentKey) {
      console.error('Content key is required for action: ', action);
      return;
    }

    triggerEl.addEventListener(event, () => {
      this[action]?.(contentKey);
    });
  }

  open(contentKey) {
    if (this.currentContentKey !== contentKey) {
      const content = document.querySelector(`[data-modal-content="${contentKey}"]`);

      if (!content) {
        console.error("Content wasn't found");
        return;
      }

      this.currentContentKey = contentKey;
      this.content.innerHTML = content.innerHTML;
    }

    super.open();
  }

  toggle(contentKey) {
    this.expanded ? this.close() : this.open(contentKey);
  }
}

// Fetch modal class
class FetchModal extends DynamicModal {
  constructor() {
    super();
  }

  async open(contentKey) {
    if (this.currentContentKey !== contentKey) {
      try {
        const response = await fetch(`?section_id=${contentKey}`);
        if (!response.ok) {
          console.error('Failed to fetch content');
          return;
        }

        const text = await response.text();
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = text;

        const content = tempDiv.querySelector('#fetch-content');
        if (!content) {
          console.error("Content wasn't found");
          return;
        }

        this.currentContentKey = contentKey;
        this.content.innerHTML = content.innerHTML;
      } catch (error) {
        console.error('Error fetching content:', error);
        return;
      }
    }

    document.documentElement.style.overflow = 'hidden';
    this.expanded = true;
  }
}

class FetchModalProductPopUp extends FetchModal {
  constructor() {
    super();
    this.contentWrapper = this.querySelector('.js-content-wrapper');
    this.previousProductId = null;
  }

  onTrigger(event, triggerEl, action = 'open', contentKey, contentType) {
    if (!triggerEl) {
      console.error("Trigger element isn't specified");
      return;
    }

    if (['open', 'toggle'].includes(action) && !contentKey) {
      console.error('Content key is required for action: ', action);
      return;
    }

    triggerEl.addEventListener(event, () => {
      this[action]?.(contentKey, contentType);
    });
  }

  async open(productId, contentType) {
    this.contentWrapper.setAttribute('data-skeleton-type', contentType);
    if (this.previousProductId !== productId || contentType !== 'productPopup') {
      this.contentWrapper.setAttribute('data-skeleton', 'false');
    }

    this.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    if (this.previousProductId === productId && contentType == 'productPopup') {
      this.contentWrapper.setAttribute('data-skeleton', 'true');
      return;
    }
    try {
      const response = await fetch(`/search/?sections=ajax-product-info-popup&q=id:${productId}&type=${contentType}`);
      if (!response.ok) throw new Error('Failed to fetch content');

      const data = await response.json();
      const domParser = new DOMParser();
      const newContent = domParser
        .parseFromString(data[Object.keys(data)[0]], 'text/html')
        .querySelector('[data-content]');

      if (newContent) {
        this.content.innerHTML = newContent.innerHTML;
        if (contentType === 'judgemePopup') {
          window.document.dispatchEvent(
            new Event('DOMContentLoaded', {
              bubbles: true,
              cancelable: true,
            })
          );
        }
      }
    } catch (error) {
      console.error('Error loading popup:', error);
    }

    this.contentWrapper.setAttribute('data-skeleton', 'true');
    this.previousProductId = contentType === 'judgemePopup' ? null : productId;
  }
}

// Modal trigger class
class ModalTrigger extends HTMLElement {
  connectedCallback() {
    const modalSelector = this.dataset.modalSelector || 'g-modal';
    const event = this.dataset.event || 'click';
    const action = this.dataset.action || 'open';
    const contentKey = this.dataset.contentKey;
    const contentType = this.dataset.contentType || 'productPopup';
    const modal = document.querySelector(modalSelector);
    if (modal) {
      modal.onTrigger(event, this, action, contentKey, contentType);
    } else {
      console.error("Modal wasn't found");
    }
  }
}

// Define custom elements
if (!window.customElements.get("g-modal")) {
  customElements.define('g-modal', GModal);
}
if (!window.customElements.get("dynamic-modal")) {
  customElements.define('dynamic-modal', DynamicModal);
}

if (!window.customElements.get("fetch-modal")) {
  customElements.define('fetch-modal', FetchModal);
}
if (!window.customElements.get("fetch-modal-product-pop-up")) {
  customElements.define('fetch-modal-product-pop-up', FetchModalProductPopUp);
}
if (!window.customElements.get("modal-trigger")) {
  customElements.define('modal-trigger', ModalTrigger);
}

var InstallmentBlock = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
    this.installmentCheckbox = this.querySelector('#addInstallment');
    this.installmentBlock = this.querySelector('.js-installation');;
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    let currentVariant = event.detail.variant["id"];
    let sectionId = this.dataset.sectionId;

    fetch(`?variant=${currentVariant}&section_id=${sectionId}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const renderedInstallment = doc.querySelector('installment-block');


        if (renderedInstallment) {
          this.innerHTML = renderedInstallment.innerHTML;

          updateInstallationCheckBtn();

          document.dispatchEvent(new CustomEvent('installment:update'));
        } else {
          console.warn('Section not found in fetched HTML');
        }
      })
      .catch(error => {
        console.error('Error fetching section:', error);
      });

  }
};
if (!window.customElements.get("installment-block")) {
  window.customElements.define("installment-block", InstallmentBlock);
}

updateInstallationCheckBtn();

function updateInstallationCheckBtn() {
  let toggleInstallments = document.querySelectorAll('.js-installation-check');
  if (toggleInstallments.length) {
    let installmentinput = document.querySelector('#addInstallment');
    let addInstallmentBtn = document.querySelector('.js-add-installment');


    if (addInstallmentBtn && installmentinput) {
      addInstallmentBtn.querySelector('span').innerHTML = installmentinput.dataset.price;
    }

    toggleInstallments.forEach((toggleInstallment) => {

      if (installmentinput) {
        toggleInstallment.querySelector('span').innerHTML = installmentinput.dataset.price;
      }

      toggleInstallment.addEventListener('click', (e) => {
        e.preventDefault();

        if (installmentinput) {
          installmentinput.checked = true;
          installmentinput.setAttribute('checked', true);
        }

        const currentPopup = document.querySelector("g-modal[aria-expanded='true']");
        if (!currentPopup) return;
        currentPopup.close();
      });
    });
  }
}

let addInstallmentBtn = document.querySelector('.js-add-installment');
if (addInstallmentBtn) {
  addInstallmentBtn.addEventListener('click', async (e) => {
    e.preventDefault();
    let installmentVariant = document.querySelector('#addInstallment');
    let installmentVariantId = installmentVariant.value;
    let installmentSize = installmentVariant.getAttribute('data-installment-products');
    let targetQuantity = document.querySelector('.quantity-selector__input').value;
    let item = document.querySelector('[name="id"]');

    let items = await fetchCart;
    items = items.items;
    console.log(items);

    const findQuantity = (items, id) => {
      const item = items.find(item => item.id === id);
      return item ? item.quantity : null;
    };

    const itemQuantity = findQuantity(items, Number(item.value));
    const remainder = itemQuantity % installmentSize;

    let installmentTotal = Math.floor(targetQuantity / installmentSize) + (remainder > 0 ? 1 : 0);

    const data = {
      id: item.value,
      quantity: itemQuantity,
      properties: {
        "_installmentProduct": `${installmentVariant.value}`,
      }
    }

    //const changeItems = // webqam - unuse variable
    await fetch(`${window.location.origin}/cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });

    const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();

    let updates = {
      [installmentVariantId]: installmentTotal,
    };

    // Webqam - modify the section with id
      const cartDrawerElement = document.querySelector('cart-drawer');
      const cartDrawerSection = cartDrawerElement ? cartDrawerElement.closest('.shopify-section') : null;
      const sectionId = cartDrawerSection ? cartDrawerSection.id.replace('shopify-section-', '') : 'cart-drawer';
    //end webqam

    let itemsToUpdate = {
      updates: updates,
      //sections: ["cart-drawer"], // webqam
      sections: sectionId,
    };

    const cartUpdate = await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(itemsToUpdate)
    });


    const responseJson = await cartUpdate.json();
    cartContent["sections"] = responseJson["sections"];

    if (cartUpdate.ok) {
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "line-item:change",
          cart: cartContent
        }
      }));

      const currentPopup = document.querySelector("g-modal[aria-expanded='true']");
      if (!currentPopup) return;
      currentPopup.close();

      document.querySelector('[aria-controls="cart-drawer"]').click();

    }

  })
}


let disableInstallmentBtns = document.querySelectorAll('.js-installation-disable');

if (disableInstallmentBtns.length > 0) {

  disableInstallmentBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      let installmentinput = document.querySelector('#addInstallment');

      installmentinput.checked = false;
      installmentinput.setAttribute('checked', false);
    })
  })
}

function formatPrice(value) {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
}

// js/common/cart/fetch-cart.js
var fetchCart = new Promise(async (resolve) => {
  resolve(await (await fetch(`${Shopify.routes.root}cart.js`)).json());
});
